export const LOGIN_CLEANUP = '@spa-nonrev/login/LOGIN_CLEANUP';
export const LOGIN_USER_FAILED = '@spa-nonrev/login/LOGIN_USER_FAILED';
export const LOGIN_USER_SUCCESS = '@spa-nonrev/login/LOGIN_USER_SUCCESS';
export const LOGIN_USER_START = '@spa-nonrev/login/LOGIN_USER_START';
export const LOGOUT_USER = '@spa-nonrev/login/LOGOUT_USER';
